module.exports = __webpack_public_path__ + "3a5e51be02bea97c5f815534b5abce4a.MP3";